var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-star",
  "data-name": "Icon material-star",
  d: "M9,12.644,12.708,15l-.984-4.44L15,7.573l-4.314-.385L9,3,7.314,7.187,3,7.573,6.276,10.56,5.292,15Z",
  transform: "translate(-3 -3)",
  fill: "#fbc52d"
})));
export default __webpack_public_path__ + "static/media/GoldenStar.e8925352.svg";
export { SvgComponent as ReactComponent };